// Page "Les looks du jour"
// 1) Un seul point (hot-spot) ouvert a la fois : ouvrir un point ferme les autres.
// 2) Sur ordinateur, la fiche produit se positionne en bas a droite du LOOK cliqué
//    (pas en bas a droite de la fenetre du navigateur). Sur mobile elle reste fixee
//    en bas a droite de l'ecran (regle CSS), un seul look etant visible a la fois.

function positionPopoverForDesktop(dot) {
  if (!window.matchMedia('(min-width: 750px)').matches) return;

  var hotSpotBlock = dot.closest('.hot-spot');
  var section = dot.closest('.shopify-section--hot-spots');
  var contentBox = section ? section.querySelector('.content-box') : null;
  if (!hotSpotBlock || !contentBox) return;

  var popover = hotSpotBlock.querySelector('.popover--hot-spot');
  if (!popover || !popover.shadowRoot) return;
  var content = popover.shadowRoot.querySelector('[part~=\"content\"]');
  if (!content) return;

  var boxRect = contentBox.getBoundingClientRect();
  var margin = 16; // 1rem

  var right = window.innerWidth - boxRect.right + margin;
  var bottom = window.innerHeight - boxRect.bottom + margin;

  if (right < margin) right = margin;
  if (bottom < margin) bottom = margin;

  content.style.setProperty('position', 'fixed', 'important');
  content.style.setProperty('top', 'auto', 'important');
  content.style.setProperty('left', 'auto', 'important');
  content.style.setProperty('right', right + 'px', 'important');
  content.style.setProperty('bottom', bottom + 'px', 'important');
}

document.addEventListener('click', function (event) {
  var dot = event.target.closest('.shopify-section--hot-spots .hot-spot__dot');
  if (!dot) return;

  var allDots = document.querySelectorAll('.shopify-section--hot-spots .hot-spot__dot');
  allDots.forEach(function (otherDot) {
    if (otherDot !== dot && otherDot.getAttribute('aria-expanded') === 'true') {
      otherDot.click();
    }
  });

  // Laisse le composant natif terminer sa propre logique d'ouverture / positionnement
  // avant d'appliquer notre position (sinon il l'écrase juste après).
  setTimeout(function () {
    positionPopoverForDesktop(dot);
  }, 0);
  setTimeout(function () {
    positionPopoverForDesktop(dot);
  }, 100);
}, true);

window.addEventListener('resize', function () {
  var expandedDot = document.querySelector('.shopify-section--hot-spots .hot-spot__dot[aria-expanded=\"true\"]');
  if (expandedDot) positionPopoverForDesktop(expandedDot);
});